import React from "react";
import { DeploymentsList } from "@src/components/deployments/DeploymentsList/DeploymentsList";
export default function DeploymentsPage() {
  return <DeploymentsList data-sentry-element="DeploymentsList" data-sentry-component="DeploymentsPage" data-sentry-source-file="index.tsx" />;
}